export function YoyCell({ pct, isThin }) {
  if (isThin) return <span style={{ color: '#9e9e9e' }}>—</span>;
  if (pct == null) return <span style={{ color: '#9e9e9e' }}>—</span>;
  const color = pct > 0 ? '#2e7d32' : pct < 0 ? '#c62828' : '#757575';
  const sign = pct > 0 ? '+' : '';
  return <span style={{ color, fontWeight: 600 }}>{sign}{pct.toFixed(1)}%</span>;
}
